import { render, staticRenderFns } from "./StoredImage.vue?vue&type=template&id=719bda34&"
import script from "./StoredImage.vue?vue&type=script&lang=js&"
export * from "./StoredImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports